import {useCallback, useState} from "react";
import {useTranslation} from "react-i18next";
import Page from "../../common/page/Page";
import ContainerBlock from "../../common/container/ContainerBlock";
import {DashboardTranslKey} from "./DashboardTranslKey";
import SubmissionsToAuthorizePanel from "./SubmissionsToAuthorizePanel";
import {Grid} from "@mui/material";
import {RecentSubmissionsPanel} from "./RecentSubmissionsPanel";
import {useUser, useUserRoles} from "../user/UserContext";
import UserRoleResolver from "../user/UserRoleResolver";
import StatisticsOverviewContainer from "../statistics/StatisticsOverviewContainer";


export function DashboardPage() {
    const {t} = useTranslation();
    const user = useUser();
    const roles = useUserRoles();

    // Bumping the key remounts both panels, which re-runs their initial data load.
    const [reloadKey, setReloadKey] = useState(0);
    const reloadDashboard = useCallback(() => setReloadKey((key) => key + 1), []);

    return (
        <Page title={t(DashboardTranslKey.DASHBOARD)} contentBlock={false}>
            {UserRoleResolver.hasStatisticsAccess(roles) && (
                <ContainerBlock>
                    <StatisticsOverviewContainer/>
                </ContainerBlock>
            )}
            <ContainerBlock>
                <Grid container spacing={4} key={reloadKey}>
                    <Grid item xs={12}>
                        {user && <SubmissionsToAuthorizePanel user={user} reloadDashboard={reloadDashboard}/>}
                    </Grid>
                    <Grid item xs={12}>
                        {user && <RecentSubmissionsPanel user={user}/>}
                    </Grid>
                </Grid>
            </ContainerBlock>
        </Page>
    );
}
